export const LOQATE_FIND_API_ENDPOINT = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';
export const LOQATE_RETRIVE_API_ENDPOINT = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.00/json3.ws';
export const DELIVERY_ADDRESS_MINIMUM_LENGTH = 2;
export const ADDRESS_MAX_LENGTH = {
    postalCode: 8,
    city: 30,
    address: 50,
};
export const INITIAL_ADDRESS_STATE_VALUE = {
    deliveryAddress: '',
    address: '',
    city: '',
    postalCode: '',
    state: '',
    country: '',
};
export const RESPONSE_LIMIT = 500;
export const LOQATE_CONTAINER_TYPE = 'Container';
export const LOQATE_ADDRESS_TYPE = 'Address';
export const DELIVERY_ADDRESS_FIELD = 'deliveryAddress';
export const ADDRESS_FIELD = 'address';
export const STATE_FIELD = 'state';
export const COUNTRY_FIELD = 'country';
export const POSTAL_CODE_FIELD = 'postalCode';
export const DELIVERY_ADDRESS_INPUT_ID = 'id-shipping-details-delivery-address';
export const DEFAULT_ADDRESS_CONFIG = {
    internalCountries: [],
    internalCountryFieldEnabled: false,
    postalCodeConfigModel: {
        alphanumericCodeExclusions: [],
        numericCodeExclusions: [],
        postalCodeRegexp: '',
    },
    stateFieldEnabled: false,
    states: [],
};
export const RANGE_SYMBOL_KEY = '-';
export const ANY_SYMBOL_KEY = '*';
